import { RootState } from '@redux/store';

export const getUserDiscountCards = (state: RootState) => state.discount.discountCards;
export const getIsLoadedCards = (state: RootState) => state.discount.isLoadedCards;
export const getIsErrorCards = (state: RootState) => state.discount.isError;
